export const REPORT_ROUTE_NAMES = {
  SALES_SUMMARY: 'reportSalesSummary',
  PERFORMANCES: 'reportsPerformances',
  DOWNLOADS: 'reportDownloads',
  WEB_ANALYTICS: 'reportWebAnalytics',
  SHOW_INSIGHTS: 'reportShowInsights',
} as const
